<img [src]="icon_url">
<tooltip-popover *ngIf="tooltip_content"
                 [tooltip_content]="tooltip_content">
</tooltip-popover>
